import Ambiente from "../utils/Ambiente";

class ConfiguracaoAm {

    get urlBaseAM() {
        return Ambiente.urlAssistenteMinuta + '/publico/';
    }
    
    get urlBaseEREC() {
        return Ambiente.urlERec + '/erec/';
    }

    get urlTemas() {
        return this.urlBaseAM + 'temas/';
    }

    get urlModelosTemas() {
        return this.urlBaseAM + 'modelos/tema/';
    }

    get urlAutotextos() {
        return this.urlBaseAM + 'camposDinamicos/';
    }

    get urlEstrutura() {
        return this.urlBaseAM + 'estrutura/';
    }

    get urlMinutasGabinete() {
        return this.urlBaseAM + 'minutas/gabinete/';
    }

    get urlMinutas() {
        return this.urlBaseAM + 'minutas/';
    }
    
    get urlParteMinuta() {
    	return this.urlBaseAM + 'minutas/';
    }
    
    get urlInfoERec() {
        return this.urlBaseEREC + 'processo/';
    }

}

export default new ConfiguracaoAm();
